import React from 'react';
import PropTypes from 'prop-types';

import cn from 'classnames';

import { Button } from 'react-md';
import { map } from 'lodash-es';

import { CoverageTypeEnum } from '../OfferBlock.enum';

const Data = ({ id, label, showDetails, existCoverages, type, handleShowDetails, children }) => (
  <div className={cn('flex-row style-row-border-top', type)}>
    <div className="flex-grid-first style-grid-border-right padding-grid">
      <div className="flex-row flex-grid-center-vertical">
        <div className="flex-grid-first-sub text-capitalize">
          <span> {label} </span>
        </div>
        {existCoverages && (
          <div className="flex-grid text-end">
            <Button icon type="button" onClick={() => handleShowDetails(id, showDetails)}>
              {showDetails !== true && 'add'}
              {showDetails === true && 'remove'}
            </Button>
          </div>
        )}
      </div>
    </div>
    {children}
  </div>
);

Data.propTypes = {
  id: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  showDetails: PropTypes.bool,
  existCoverages: PropTypes.bool.isRequired,
  type: PropTypes.oneOf(map(CoverageTypeEnum, item => item)),
  handleShowDetails: PropTypes.func,
  // eslint-disable-next-line react/forbid-prop-types
  children: PropTypes.any.isRequired,
};

Data.defaultProps = {
  showDetails: false,
  type: undefined,
  handleShowDetails: () => {},
};

export default Data;
